<script setup lang="ts">
import { computed } from 'vue';
import useStickyAlerts from '@/modules/alerts/composables/useStickyAlerts';
import { StickyAlertType } from '@/modules/alerts/models/sticky-alert-type';
import STICKY_ALERT_COMPONENT_REGISTRY from '@/modules/alerts/models/sticky-alert-component-registry';
import usePlatform from '@/modules/platform/composables/usePlatform';

const { platform } = usePlatform();
const { alerts } = useStickyAlerts();

const getComponent = (alertType: StickyAlertType) => {
  return STICKY_ALERT_COMPONENT_REGISTRY[alertType];
};

const widthClass = computed(() => {
  return { 'w-100': !platform.value.isMobile };
});
</script>

<template>
  <div class="d-flex flex-column mt-2 px-2 container-xl sticky-alert-root" :class="widthClass">
    <div v-for="alert in alerts" :key="alert.props.id" class="d-flex justify-content-center mb-2">
      <component :is="getComponent(alert.stickyAlertType)" v-bind="alert.props" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.sticky-alert-root {
  position: absolute;
  // This is the largest width that does not cover the back arrow on mobile.
  // Once the back arrow becomes part of the header, this should be set to 100%.
  width: 86%;
  left: 50%;
  transform: translate(-50%, 0);
}
</style>
